import BaseMCatalogTemplate from "../../components/Catalog/BaseMCatalogTemplate";
import { ECatalogFilter } from "../../components/Catalog/ECatalogFilter";
import { TCatalogTemplate } from "./TCatalogTemplate";

export default class MCatalogTemplate extends BaseMCatalogTemplate {
  protected entity: TCatalogTemplate;

  constructor(container: HTMLElement) {
    super(container);
    const { id, language, difficulty, grade, subject, type, themes } =
      container.dataset;
    this.entity = {
      id: +id,
      language: +language,
      grades: grade ? JSON.parse(grade) : null,
      difficulties: difficulty ? JSON.parse(difficulty) : null,
      subjects: subject ? JSON.parse(subject) : null,
      type: +type === 0 || +type === 1 ? +type : null,
      themes: themes ? JSON.parse(themes) : null,
    };
  }

  get container(): HTMLElement {
    return this._container;
  }

  public get language(): number {
    return this.entity.language;
  }

  public get type(): number {
    return this.entity.type;
  }

  public HasFilter(key: number | number[], type: ECatalogFilter) {
    if (key === -1) {
      return true;
    }
    switch (type) {
      case ECatalogFilter.DIFFICULTY:
        return this.hasDifficulty(key as number);
      case ECatalogFilter.GRADE:
        return this.hasGrade(key as number);
      case ECatalogFilter.LANGUAGE:
        return this.language === key;
      case ECatalogFilter.REGION:
        return this.hasTheme(key as number[]);
      case ECatalogFilter.SUBJECT:
        return this.hasSubject(key as number);
      case ECatalogFilter.TYPE:
        return key === this.type;
    }
  }

  private hasGrade(key: number): boolean {
    return this.entity.grades ? this.entity.grades.includes(key) : null;
  }

  private hasSubject(key: number): boolean {
    return this.entity.subjects ? this.entity.subjects.includes(key) : null;
  }

  private hasTheme(themes: number[]): boolean {
    if (this.entity.themes.length === 0 || themes.length === 0) {
      return true;
    }
    return themes.every((theme) => this.entity.themes.includes(theme));
  }
}
